<template>
  <el-dialog custom-class="mobile-fullscreen" :visible.sync="isVisible" width="80%" @close="handleClose">
    <div class="pl-30 pr-30">
      <div class="row">
        <div class="col-lg-7">
          <h4>Mastercard acceptance</h4>
          <h6>Accept Mastercard, open possibilities.</h6>
          <p>Visa, MasterCard, American Express, Diners Club/DISCOVER and JCB are the most popular payment methods in e-commerce. Around 1.3 billion Visa cards and over 700 million MasterCards are used worldwide every day. Ensure lightning fast purchasing decisions in your online shop with a desirable buying public.</p>
          <p>MasterCard is a financial services organisation which processes the transactions carried out on credit cards operated by a range of banks and other lenders. When you see the MasterCard symbol in the bottom corner of a credit card it means the company’s technology will be used to process and authorise any transactions you make with it.</p>

          <div class="row mt-4">
            <div class="col">
              <div class="modal-table">
                <ul>
                  <li><span>Refund fee</span><span>0.25 EUR</span></li>
                  <li><span>Diasgio</span><span>2.70%</span></li>
                  <li><span>Transaction fee</span><span>0.25 EUR</span></li>
                  <li><span>Chargeback fee</span><span>25.00 EUR</span></li>
                </ul>
              </div>
            </div>
            <div class="col">
              <div class="modal-table">
                <ul>
                  <li><span>Immediate coverage veriﬁcation </span><i class='uil uil-check'></i></li>
                  <li><span>Global accessibility</span><i class='uil uil-check'></i></li>
                  <li><span>Maximum sales increase</span><i class='uil uil-check'></i></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 text-center">
          <figure class="figure mb-30 mt-15 d-block">
            <img src="@/assets/mastercard-world.png" alt="mastercard world" class="img-fluid">
            <figcaption class="figure-caption text-center">Mastercard worldwide acceptance</figcaption>
          </figure>
          <button class="btn" @click="activateOption()">Activate Now</button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'mastercard-modal',
  computed: {
    ...mapFields({
      isVisible: 'ui.modals.MastercardModal.visible',
    })
  },
  methods: {
    handleClose() {
      this.closeModal()
    },
    activateOption() {
      this.closeModal()
      this.$store.commit('updateMastercardField', true)
    },
    closeModal() {
      this.$store.commit('showHideModal', {
        modal: 'MastercardModal',
        show: false
      })
    }
  }
}
</script>
